'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const ContextComponent = require('../../../global/components/ContextComponent');

const SocialIcon = require('../../../global/components/SocialIcon');
const PinterestIcon = require('dibs-vg/dist/react/pinterest');

const pinterestUtils = require('../../../global/utils/social/pinterest');
const pinterestActions = require('../../../global/actions/pinterestActions');

class Pinterest extends ContextComponent {

    constructor(props) {
        super(props);
        this.pin = this.pin.bind(this);
    }

    _onPin() {
        const {onPin} = this.props;

        if (typeof onPin === 'function') {
            onPin();
        }
    }

    openWindow() {
        return pinterestUtils.openWindow();
    }

    pin() {
        const {url, media, description, copy, connectAccounts} = this.props;
        const pinterestWindow = this.openWindow();

        if (connectAccounts) {
            const tracking = copy.tracking.connectModalPinClicked;
            this.context.executeAction(pinterestActions.showConnectModalAfterPinAdded, {
                pinterestWindow, url, media, description, tracking
            });
        } else {
            this.context.executeAction(pinterestActions.pin, {pinterestWindow, url, media, description});
        }

        this._onPin();
    }

    render() {
        const {iconType} = this.props;

        return (
            <SocialIcon onClick={this.pin} Icon={PinterestIcon} iconName="pinterest" iconType={iconType} data-tn="pinterest" />
        );
    }

}

Pinterest.displayName = 'Pinterest';

Pinterest.propTypes = {
    url: PropTypes.string.isRequired,
    media: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    copy: PropTypes.object.isRequired,
    connectAccounts: PropTypes.bool,
    iconType: PropTypes.string,
    onPin: PropTypes.func
};

Pinterest.defaultProps = {
    url: '',
    media: '',
    description: ''
};

module.exports = Pinterest;



// WEBPACK FOOTER //
// ./assets/js/global/components/Pinterest/Icon.jsx